"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemorySessionStorage = void 0;
/**
 * Simple implementation of [[ParsecSessionStorage]] that does not saves data. Useful for testing
 * or single, non-repeating operation. In other cases it is recommended to use persistent implementations
 * like [[LocalSessionStorage]].
 *
 */
class MemorySessionStorage {
    constructor() {
        this.data = new Map();
    }
    getItem(key) {
        var _a;
        return (_a = this.data.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    removeItem(key) {
        this.data.delete(key);
    }
    setItem(key, value) {
        this.data.set(key, value);
    }
    /**
     * Create copy of the current data.
     * @return new instance with copied data
     */
    toMap() {
        return new Map(this.data);
    }
    /**
     * Merge data from a map od another MemorySessionStorage, overriding existing values.
     * @param other map or storage to merge
     * @return updated this
     */
    addAll(other) {
        const m = other instanceof Map ? other : other.data;
        for (const [k, v] of m) {
            this.data.set(k, v);
        }
        return this;
    }
    clear() {
        this.data.clear();
    }
}
exports.MemorySessionStorage = MemorySessionStorage;
//# sourceMappingURL=MemorySessionStorage.js.map